// extracted by mini-css-extract-plugin
module.exports = {"filterMenu":"FilterMenu_filterMenu__0cL37","menuItem":"FilterMenu_menuItem__2S21m","menuLabel":"FilterMenu_menuLabel__B4FR5","iconWrapper":"FilterMenu_iconWrapper__y_Bgk"};